<template>
  <smd-one-col-layout>
    <div class="smd-header smd-form__row reset-m"
         slot="header">
      <span class="ns-icon-ico028"
            @click="goBack"/>
      <text-string class="modal-watsons-terms-and-conditions__header-title"
                   label-id="txt131"/>
      <span class="ns-icon-ico001">
        <span class="path1"></span>
        <span class="path2"></span>
      </span>
    </div>

    <div>
      <text-string label-id="txt588"/>

      <div class="smd-checkbox__row m-t-25">
        <smd-checkbox class="modal-watsons-terms-and-conditions__checkbox" v-model="isChecked">
          <text-string label-id="txt589"/>
        </smd-checkbox>
      </div>
    </div>
  </smd-one-col-layout>
</template>

<script>
  import CloseModalMixin from '@/mixins/close-modal-mixin';

  export default {
    name: "modal-watsons-terms-and-conditions",
    mixins: [CloseModalMixin],
    data() {
      return {
        isChecked: true
      }
    },
    props: {
      termsAccepted: {type: Boolean, default: true}
    },
    methods: {
      goBack() {
        this.closeModal({checked: this.isChecked})
      }
    },
    mounted() {
      this.isChecked = this.termsAccepted
    }
  }
</script>

<style lang="scss">
  @import "~@/assets/styles/util.scss";

  .modal-watsons-terms-and-conditions__header-title {
    flex: 1;
    text-align: center;
  }

  .modal-watsons-terms-and-conditions__checkbox {
    align-items: flex-start !important;
  }
</style>